import { render } from "./TopThree.vue?vue&type=template&id=276cabe2"
import script from "./TopThree.vue?vue&type=script&lang=js"
export * from "./TopThree.vue?vue&type=script&lang=js"

import "./TopThree.vue?vue&type=style&index=0&id=276cabe2&lang=css"

import exportComponent from "C:\\Users\\Kevin\\Desktop\\ArbeitFinderundBeraterVersionen\\MonitorBerater\\MonitorweltBerater\\FindingoBerater\\BeforeWordpressBerater_new_WordpressProduction\\newDataForm\\newDataForm\\form_try0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__